<template>
  <div class="content-area">
    <div class="error-panel content-area">
      <infopanel v-once>
        <template slot="title"></template>
        <template slot="body">
          <div class="row">
            <div class="col-sm-12 col-xs-12 warning-text text-center">
              <h1>Opps! Something unexpected happend!</h1>
              <p>
                Sorry but we can't process your request at this time, please try again and if it
                happens again please contact support and they'll be glad to look into it for you.
              </p>
            </div>
          </div>
        </template>
      </infopanel>
    </div>
  </div>
</template>

<script>
import InfoPanel from '@/components/InfoPanel';

export default {
  components: {
    infopanel: InfoPanel,
  },
};
</script>

<style scoped>
.error-panel {
  margin-top: 140px;
}
</style>
